import { ReactNode } from 'react';

import SimulatorCard from './SimulatorCard';
import SimulatorListItem from './SimulatorListItem';
import { RenderModeEnum } from '../../../../utils/widgets';
import { useWidgetSimulatorsContext } from '../utils/context';

type SimulatorItemProps = {
	name: string;
	backgroundColor: string;
	icon: ReactNode;
};

const SimulatorItem = ({ name, backgroundColor, icon }: SimulatorItemProps) => {
	const { renderMode } = useWidgetSimulatorsContext();

	return renderMode === RenderModeEnum.LIST ? (
		<SimulatorListItem backgroundColor={backgroundColor} name={name} svgIcon={icon} />
	) : (
		<SimulatorCard name={name} image={icon} backgroundColor={backgroundColor} />
	);
};

export default SimulatorItem;
